import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import ThumbnailDownloader from './components/ThumbnailDownloader';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <Header />
        <main className="container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<ThumbnailDownloader />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;